import React from 'react';
import styled from 'styled-components';

import { h3Styles } from 'partials/typography';
import Image from 'partials/Image';

export default props => {
    const { data, pageBackground } = props;
    return (
        <TeachersWidget pageBackground={pageBackground}>
            <ul>
                {data.map((row, i) => {
                        return (
                            <li key={i}>
                                <Image image={row.acf.image} className="image" background ratio="1:1" />
                                <div className="info">
                                    <div>{row.post_title}</div>
                                    <div>{row.acf.intro}</div>
                                </div>
                            </li>
                        );
                })}
            </ul>
        </TeachersWidget>
    );
}

const TeachersWidget = styled.li`
    margin-bottom:10px;
    
    ul {
        li {
            display: flex;
            margin-bottom:40px;
            .image {
                min-width: 110px;
                min-height: 110px;
                padding-top: 0;
                display: flex;
                max-width: 110px;
                max-height: 110px;
                border-radius: 110px;
                margin-right:15px;
            }
            .info {
                div {
                    ${props => props.pageBackground === 'main' ? `
                        color: #fff;
                    ` : ``}
                    &:first-child {
                        ${h3Styles}
                        margin-top: -10px;
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/RichText/TeachersWidget.js